import { Box, FormControl, Typography } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import React, { memo } from 'react'
import Delete from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add';
import { FormOneRangeEdit } from './FormOneRangeEdit'
import { generateRandomID } from 'helpers/generateRandomID'

export const FormRangesEdit = memo((props) => {
  const { setRanges, ranges } = props

  return (
    <>
      <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: 30, width: '98%'}}>
        <Typography style={{ alignSelf: 'center' }}>Agregar Rango</Typography>
        <RegularButton 
          round 
          justIcon 
          color="info" 
          style={{ margin: 10 }} 
          onClick={() => setRanges([...ranges, {
            id: generateRandomID(32), 
            min: ranges[ranges.length - 1].max + 0.01,
            max: ranges[ranges.length - 1].max + 0.01,
            price: 0 
          }])}
        >
          <AddIcon style={{ margin: 0 }}/>
        </RegularButton>
      </Box>
      {
        ranges && ranges.sort((a,b) => a.min - b.min).map(range => (
          <FormControl key={range.id} style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            gap: 10, 
            marginTop: 20, 
            alignItems: 'center', 
            flexDirection: 'row', 
            width: '90%'
          }}>
            <FormControl style={{display: 'flex', justifyContent: 'space.between', gap: 10, flexDirection: 'row', flexGrow: 1}} variant="outlined">
              <FormOneRangeEdit key={range.id} range={range} ranges={ranges} setRanges={setRanges}/>
            </FormControl>
            <RegularButton 
              round 
              justIcon 
              color={"danger"} 
              style={{ margin: 0 }}
              disabled={ranges.length === 1 || ranges[ranges.length - 1].id !== range.id} 
              onClick={(e) => {
                e.stopPropagation()
                setRanges(ranges.filter(item => item.id !== range.id))
              }}
            >
              <Delete style={{ margin: 0 }}/>
            </RegularButton>
          </FormControl>
        ))
      }
    </>
  )
})
